import { useAsyncCallback } from 'apps/sigma2-ui/src/lib/hooks/useAsyncCallback';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { GenerateShareLinkRequest } from 'libs/end-to-end/src/links';
import { GenerateShareLinkResult } from 'libs/end-to-end/src/links';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const useBasicCopilotOnFetchShareLink = ({
  userAuthenticatedApiCall,
  request,
  setCurrentShareLink,
  setShowShareLinkModal,
  isFetchingShareLink,
  setIsFetchingShareLink,
}: {
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
  request: CustomVizRequest | null;
  setCurrentShareLink: Setter<string>;
  setShowShareLinkModal: Setter<boolean>;
  isFetchingShareLink: boolean;
  setIsFetchingShareLink: Setter<boolean>;
}) => {
  return useAsyncCallback(
    async (isAlive) => {
      if (!isAlive() || isFetchingShareLink || !request) {
        return;
      }

      setIsFetchingShareLink(true);

      const requestBody: GenerateShareLinkRequest = {
        baseUrl: window.location.origin,
        request,
      };

      const generateShareLinkResult = await userAuthenticatedApiCall({
        url: `${getApiBaseUrl()}/share/generate`,
        requestOptions: {
          method: 'POST',
          body: JSON.stringify(requestBody),
        },
        responseSchema: GenerateShareLinkResult,
      });
      if (
        !generateShareLinkResult ||
        generateShareLinkResult.resultType === 'err'
      ) {
        setIsFetchingShareLink(false);
        return;
      }

      setIsFetchingShareLink(false);

      const link = generateShareLinkResult.value.shareLink;

      setCurrentShareLink(link);
      setShowShareLinkModal(true);
    },
    [
      isFetchingShareLink,
      request,
      setCurrentShareLink,
      setIsFetchingShareLink,
      setShowShareLinkModal,
      userAuthenticatedApiCall,
    ],
  );
};
